module.exports = __webpack_public_path__ + "static/media/virtual-uploadPhoto.9d3f41e9.svg";